import axios from 'axios';
import { API_URL } from '../config/environment-variables';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import {
  FETCH_ENDPOINT_ACCESS,
  FETCH_SALES_OPENING_START_TIME,
  FETCH_USER,
  FETCH_USER_MACHINES,
  REQUEST_RESULT,
} from './types';
import { getUserId, headerConfig } from './utils';
import { LOCAL_STORAGE_BUSINESS_START_TIME, LOCAL_STORAGE_ENDPOINT_ACCESS } from './auth-actions';
import { analyticEvent } from '../analytics';

export function fetchUser() {
  return dispatch => axios.get(`${API_URL}/WebUser/${getUserId()}`, dispatch(headerConfig()))
    .then(response => {
        return dispatch({
          type: FETCH_USER,
          payload: response.data.Item,
        });
      },
    )
    .catch(error => {
      dispatch({
        type: REQUEST_RESULT,
        payload: { message: error.response.data },
      });
    });
}

export function updateUser(values, form, setIsAccountUpdated) {
  const { firstName, lastName, oldPassword, newPassword, confirmPassword } = values;
  const { username } = values;
  
  const userId = getUserId();
  return dispatch =>
    axios.put(
      `${API_URL}/webuser/update-user/`,
      {
        ID: userId,
        Firstname: firstName,
        Lastname: lastName,
        NewPassword: newPassword,
        NewPasswordConfirm: confirmPassword,
        CurrentPassword: oldPassword,
      },
      dispatch(headerConfig()))
      .then(() => {
        form.resetForm();
        setIsAccountUpdated(true);
        dispatch(fetchUser());
        analyticEvent('User Profile', 'Edit Attempt', 'Success', { user: username });
      })
      .catch(error => {
        setIsAccountUpdated(false);
        form.setSubmitting(false);
        analyticEvent('User Profile', 'Edit Attempt', 'Failure', { user: username });
        dispatch({
          type: REQUEST_RESULT,
          payload: { message: error.response.data },
        });
        if (error.response.status === 400 && error.response.data === 'Invalid current password!') {
          form.setErrors({
            oldPassword: <FormattedMessage
              id="form.user-settings.change-password.field.password.error.current"
              defaultMessage="The current password provided is incorrect"
            />,
          });
        }
      });
}

export function fetchMachines() {
  return dispatch => axios.get(`${API_URL}/machine`, dispatch(headerConfig()))
    .then(response => {
        return dispatch({
          type: FETCH_USER_MACHINES,
          payload: response.data.Items,
        });
      },
    )
    .catch((error) => {
      dispatch({
        type: REQUEST_RESULT,
        payload: { message: error.response.status === 400 ? error.response.data : 'Error: fetching user machines' },
      });
    });
}

export function fetchBusinessSalesStart() {
  return dispatch => {
    const storedFormattedSalesStartString = localStorage.getItem(LOCAL_STORAGE_BUSINESS_START_TIME);
    
    if (storedFormattedSalesStartString) {
      const storedFormattedSalesStart = JSON.parse(storedFormattedSalesStartString);
      dispatch({
        type: FETCH_SALES_OPENING_START_TIME,
        payload: storedFormattedSalesStart,
      });
    } else {
      axios.get(`${API_URL}/settings`, dispatch(headerConfig()))
        .then(response => {
          const businessOpeningTime = response.data.BusinessOpeningTime;
          localStorage.setItem(LOCAL_STORAGE_BUSINESS_START_TIME, JSON.stringify(businessOpeningTime));
          dispatch({
            type: FETCH_SALES_OPENING_START_TIME,
            payload: businessOpeningTime,
          });
        })
        .catch(error => {
          dispatch({
            type: REQUEST_RESULT,
            payload: {
              message: error.response.status === 400 ? error.response.data : 'Error: business opening start time',
            },
          });
        });
    }
  };
}

export function fetchEndpointAccess() {
  return dispatch => {
    const storedEndpointAccess = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ENDPOINT_ACCESS));
    
    if (storedEndpointAccess) {
      dispatch({
        type: FETCH_ENDPOINT_ACCESS,
        payload: storedEndpointAccess,
      });
    } else {
      axios.get(`${API_URL}/endpointaccess`, dispatch(headerConfig()))
        .then(response => {
            localStorage.setItem(LOCAL_STORAGE_ENDPOINT_ACCESS, JSON.stringify(response.data.MenuDefinition));
            return dispatch({
              type: FETCH_ENDPOINT_ACCESS,
              payload: response.data.MenuDefinition,
            });
          },
        )
        .catch((error) => {
          dispatch({
            type: REQUEST_RESULT,
            payload: { message: error.response.status === 400 ? error.response.data : 'Error: fetching endpoints access' },
          });
        });
    }
  };
}